export default "__VITE_ASSET__CWfWKzuj__"